import { useEffect, useRef } from "react";

const UploadWidget = ({ setCourseDetails }) => {
  const cloudinaryRef = useRef();
  const widgetRef = useRef();
  useEffect(() => {
    cloudinaryRef.current = window.cloudinary;
    widgetRef.current = cloudinaryRef.current.createUploadWidget(
      {
        cloudName: "dkvh16kiu",
        uploadPreset: "iosmgt3d",
      },
      (error, result) => {
        if (result["event"] === "success") {
          const { secure_url, thumbnail_url } = result["info"];
          console.log(secure_url, thumbnail_url);
          setCourseDetails((prev) => ({
            ...prev,
            links: [...prev["links"], { secure_url, thumbnail_url }],
          }));
        }
      }
    );
  }, []);
  return (
    <button
      onClick={() => {
        widgetRef.current.open();
      }}
      style={{
        color: "#fefefe",
        fontWeight: "800",
        fontSize: "2em",
        border: "1px dashed #fefefe",
        padding: "0.5em",
      }}
    >
      UPLOAD VIDEOS
    </button>
  );
};

export default UploadWidget;
